import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import MallVouchersByStatusQuery from '@/plugins/graphql/queries/v2/store_add_ons/mall-vouchers-by-status.gql';
import { VouchersByStatusModel } from '@/helpers/entities/models/VouchersByStatusModel';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import SearchMixin from '@/helpers/vue_mixins/v2/SearchMixin';
import VoucherDetails from '@/components/v2/store_add_ons/VoucherDetails.vue';
import NewVoucherSubscription from '@/plugins/graphql/subscriptions/v2/voucher-create.gql';
let VouchersByStatus = class VouchersByStatus extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, SearchMixin) {
    constructor() {
        super(...arguments);
        this.totalCount = 0;
        this.selected = '';
    }
    get voucherStatus() {
        if (this.status === 'valid') {
            return 'available';
        }
        return this.status;
    }
    get queryOnFlight() {
        if (this.vouchers) {
            return this.$apollo.queries.vouchers.loading;
        }
        return true;
    }
    get pageTitle() {
        const formattedStatus = this.status.replace('_', ' ');
        return `${formattedStatus} Vouchers ${this.totalCount}`;
    }
    get displayOption() {
        if (this.totalCount > 0) {
            return 'xs7';
        }
        return 'xs12';
    }
    get headers() {
        const initialHeader = [
            {
                text: 'VOUCHER CODE',
                value: 'serialId',
                align: 'left',
                sortable: false,
            },
            {
                text: 'VOUCHER OWNER',
                value: 'customerFullName',
                align: 'left',
                sortable: false,
            },
        ];
        if (this.showRedeemedByHeader) {
            initialHeader.push({
                text: 'REDEEMED BY',
                value: 'voucherKyc.firstName',
                align: 'left',
                sortable: false,
            });
        }
        if (this.status === 'redeemed') {
            initialHeader.push({
                text: 'REDEEMED DATE',
                value: 'formattedUsedAt.',
                align: 'left',
                sortable: false,
            });
        }
        else {
            initialHeader.push({
                text: 'DATE APPROVED',
                value: 'formattedCreatedAt',
                align: 'left',
                sortable: false,
            });
        }
        initialHeader.push({
            text: 'VOUCHER AMOUNT',
            value: 'amount',
            align: 'left',
            sortable: false,
        });
        return initialHeader;
    }
    select(SerialId) {
        this.selected = SerialId;
    }
    get selectedSerialId() {
        return this.selected;
    }
    get showRedeemedByHeader() {
        if (this.vouchers) {
            if (this.vouchers[0].voucherKyc || !!this.vouchers[0].order) {
                return true;
            }
        }
        return false;
    }
};
__decorate([
    Prop({ type: String, required: true })
], VouchersByStatus.prototype, "status", void 0);
VouchersByStatus = __decorate([
    Component({
        components: {
            BaseSearchInput,
            VoucherDetails,
        },
        apollo: {
            vouchers: {
                query: MallVouchersByStatusQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                        status: this.voucherStatus,
                        keyword: this.search,
                    };
                },
                update(data) {
                    const vouchers = data.mallVouchersByStatus.edges;
                    const voucherNodes = (voucher) => {
                        return new VouchersByStatusModel(voucher.node);
                    };
                    this.totalCount = data.mallVouchersByStatus.totalCount;
                    if (this.totalCount > 0) {
                        this.select(vouchers[0].node.serialId);
                    }
                    return vouchers.map(voucherNodes);
                },
                fetchPolicy: 'cache-and-network',
                subscribeToMore: {
                    document: NewVoucherSubscription,
                    variables() {
                        return {
                            appUuid: this.baseAppUUID,
                            status: this.voucherStatus,
                        };
                    },
                    updateQuery: (previousResult, { subscriptionData }) => {
                        const newVoucherStatus = subscriptionData.data.voucherCreate;
                        previousResult.mallVouchersByStatus.edges.unshift({
                            node: newVoucherStatus,
                            __typename: 'VoucherEdge',
                        });
                        return previousResult;
                    },
                },
            },
        },
    })
], VouchersByStatus);
export default VouchersByStatus;
